import React from 'react';
import { useSelector } from 'react-redux';
import dateFormat from 'dateformat';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Chip,
  Tooltip
} from '@mui/material';
import {
  Add as AddIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import ApiKeyUsageTooltip from '#component/user/settings/api-key/usage-tooltip';
import { formatApiKey, isExpired } from '#component/user/settings/api-key/util';
import {
  APIKeyText,
  CardContainer,
  DateContainer,
  EmptyStateCard,
  EmptyStateIcon,
  ExpireContainer,
  Header,
  HeaderLeft,
  LabelText,
  StyledCardContent,
  StyledCardHeader
} from './styles';
import { getDateTimeFormat } from '#helper';

const MobileView = props => {
  const { apiKeys, setCreateDialogOpen, handleDeleteClick } = props;
  const measurementSystem = useSelector(state => state.account?.measurementSystem);
  const dateShortFormat = getDateTimeFormat(measurementSystem, 'dateShort');
  const dateTimeShortFormat = getDateTimeFormat(measurementSystem, 'dateTimeShort');

  return (
    <Box>
      <Header>
        <HeaderLeft>
          <Typography variant="h4" component="h1">
            API Keys
          </Typography>
          {apiKeys.length > 0 && <ApiKeyUsageTooltip />}
        </HeaderLeft>
        <Button
          color="secondary"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setCreateDialogOpen(true)}
        >
          Generate API Key
        </Button>
      </Header>

      {apiKeys.length === 0 ? (
        <Card>
          <EmptyStateCard>
            <EmptyStateIcon />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No API keys found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Generate your first API key to get started
            </Typography>
          </EmptyStateCard>
        </Card>
      ) : (
        <CardContainer>
          {apiKeys.map(apiKey => (
            <Card key={apiKey.id} variant="outlined">
              <CardContent>
                <StyledCardHeader>
                  <StyledCardContent>
                    {apiKey.label && (
                      <LabelText
                        variant="h6"
                        gutterBottom
                        title={apiKey.label}
                      >
                        {apiKey.label}
                      </LabelText>
                    )}
                    <APIKeyText variant="body2" color="text.secondary">
                      {formatApiKey(apiKey.startChar, apiKey.endChar)}
                    </APIKeyText>
                  </StyledCardContent>
                  <Tooltip title="Delete API Key">
                    <IconButton
                      color="error"
                      onClick={() => handleDeleteClick(apiKey.id)}
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </StyledCardHeader>

                <DateContainer>
                  <Typography variant="caption" color="text.secondary">
                    Created:
                    {' '}
                    {dateFormat(apiKey.creationDate, dateShortFormat)}
                  </Typography>
                  {apiKey.expirationDate && (
                    <ExpireContainer>
                      <Typography variant="caption" color="text.secondary">
                        Expires:
                        {' '}
                        {dateFormat(apiKey.expirationDate, dateTimeShortFormat)}
                      </Typography>
                      {isExpired(apiKey.expirationDate) && (
                        <Chip label="Expired" color="error" size="small" />
                      )}
                    </ExpireContainer>
                  )}
                </DateContainer>
              </CardContent>
            </Card>
          ))}
        </CardContainer>
      )}
    </Box>
  );
};

export default MobileView;
